import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';
import { articleImages } from '@/mocks/articleImages';

interface ArticleListProps {
  articles: Article[];
}

export default function ArticleList({ articles }: ArticleListProps) {
  if (articles.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-100 flex items-center justify-center">
          <i className="ri-inbox-line text-2xl text-foreground-400"></i>
        </div>
        <p className="text-foreground-500 text-sm">该分类下暂无文章</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
      {articles.map((article) => {
        const imgSrc = articleImages[article.imageSeq] || articleImages['article-01'];

        return (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group cursor-pointer"
          >
            <article className="bg-background-50 rounded-2xl overflow-hidden h-full flex flex-col">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={imgSrc}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`今日看料 - ${article.title}`}
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2 py-0.5 rounded">
                    {article.categoryName}
                  </span>
                  {article.isHot && (
                    <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded flex items-center gap-0.5">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  )}
                  {article.isTop && (
                    <span className="text-xs text-secondary-600 font-medium bg-secondary-100 px-2 py-0.5 rounded flex items-center gap-0.5">
                      <i className="ri-pushpin-line text-[10px]"></i>顶
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors flex-1">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.viewCount > 10000
                      ? `${(article.viewCount / 10000).toFixed(1)}万阅读`
                      : `${article.viewCount}阅读`}
                  </span>
                </div>
              </div>
            </article>
          </Link>
        );
      })}
    </div>
  );
}